<template>
  <b-list-group class="pl-3">
    <b-list-group-item v-for="row in subscriptions" :key="row.id">
      <b-container>
        <b-row class="d-flex justify-content-between">
          <b-col cols="10">
            <b>{{ row.name }}</b>
          </b-col>
          <b-col>
            {{ row.value | decimal }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10">
            {{ row.start_at | dateBr }} até {{ row.finish_at | dateBr }}
          </b-col>
          <b-col>
            <status-chip :status="row.payment_status" />
          </b-col>
        </b-row>
        <b-row class="text-right">
          <b-col>
            <b-button
              size="sm"
              v-if="hasBoleto(row)"
              @click="handleOpenBoleto(row)"
              variant="success"
              style="margin-left: 5px"
            >
              <i class="fas fa-print" /> Imprimir Boleto
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import statusChip from "./../sections/statusChip";

export default {
  components: {
    statusChip,
  },

  props: {
    subscriptions: {},
  },

  methods: {
    hasBoleto(subscription) {
      let subscriptionPayment = this.getSubscriptionPayment(subscription);

      return (
        subscriptionPayment.payment_method == "boleto" &&
        subscriptionPayment.status == "waiting_payment"
      );
    },

    getSubscriptionPayment(subscription) {
      if (subscription.subscription_payment.length > 0) {
        return subscription.subscription_payment[0];
      } else {
        return {};
      }
    },

    getBoletoUrl(subscription) {
      if (subscription.subscription_payment.length > 0) {
        return subscription.subscription_payment[0].transaction_boleto_url;
      }
    },

    handleOpenBoleto(subscription) {
      let url = this.getBoletoUrl(subscription);
      window.open(url);
    },
  },
};
</script>
